import {
  BooleanInput,
  DateInput,
  Edit,
  NumberInput,
  SelectInput,
  SimpleForm,
  TextInput,
  useNotify,
  useRefresh,
} from 'react-admin';
import { useParams } from 'react-router-dom';
import { LABELS } from 'shared/constants/labels';
import { httpClient } from 'shared/services/http-client';
import { API_BASE_URL_ADMIN } from 'shared/config';

export const PromocodesEdit = () => {
  const { id } = useParams();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async (payload: any) => {
    try {
      if (payload.discountType === 'amount') {
        payload.percentage = null;

        if (!payload.amount) {
          notify('Номинал не может быть пустым', { type: 'error' });
          return;
        }
      }

      if (payload.discountType === 'percentage') {
        payload.amount = null;

        if (!payload.percentage) {
          notify('Процент не может быть пустым', { type: 'error' });
          return;
        }
      }
      
      const url = `${API_BASE_URL_ADMIN}/promocodes/${id}`;

      await httpClient(url, {
        method: 'PATCH',
        body: JSON.stringify(payload),
      });

      notify('Промокод успешно обновлен', { type: 'success' });
      refresh();

    } catch (error: unknown) {
      notify('Ошибка при обновлении промокода', { type: 'error' });
      refresh();
    }
  };

  return (
    <Edit>
      <SimpleForm onSubmit={handleSubmit}>
        <TextInput label={LABELS.promocodeCode} source="code" fullWidth />
        <SelectInput
          label={LABELS.promocodeType}
          source="discountType"
          choices={[
            { id: 'amount', name: 'С номинальными' },
            { id: 'percentage', name: 'С процентом' },
          ]}
          sx={{
            '& .RaImageField-image': {
              width: 300,
              height: 300,
              objectFit: 'cover',
            },
          }}
        />
        <NumberInput label={LABELS.promocodeAmount} source="amount" fullWidth />
        <NumberInput label={LABELS.promocodePercentage} source="percentage" fullWidth />
        <NumberInput label={LABELS.promocodeLimitPerUser} source="useLimitPerUser" fullWidth />
        <DateInput label={LABELS.promocodeExpireDate} source="expireDate" fullWidth />
        <BooleanInput label={LABELS.promocodeFirstUseOnly} source="firstUseOnly" />
      </SimpleForm>
    </Edit>
  );
};
